export default __webpack_public_path__ + "static/media/c1.0883a53c.png";